export default {
	common: {
		add: 'add',
		delete: 'delete',
		detail: 'detail',
		modify: 'modify',
		search: 'search',
		reset: 'reset',
		seq: 'seq',
		operation: 'operation',
		copy: 'copy',
		moveUp: 'up',
		moveDown: 'down',
		errTip: 'error tip',
	},
	login: {
		welcome2Login: 'welcome to login',
		login: 'login',
		reset: 'reset',
	},
	navigator: {
		userInfo: 'userinfo',
	},
	selectLang: {
		switchLang: 'switch language',
		switchLangMsg: 'Switch Language Success',
	},
	menus: {
		home: 'home',
		flow: 'flow center',
		mail: 'send and receive mail',
		personal: 'personal settings',
	},
	approvalItem: {
		addCommonLanguage: 'add common language',
		commonLanguageType: 'common language types',
		commonLanguage: 'common language',
	},
	myLayout: {
		myLayoutName: 'layout name',
		valid: 'valid',
		setValid: 'As effective',
	},
	eip: {
		common: {
			search: 'search',
			reset: 'reset',
			save: 'save',
			cancel: 'cancel',
			up: 'up',
			down: 'down',
			remove: 'remove',
			clear: 'clear',
			index: 'index',
			selected: 'selected',
		},
		tree: {
			filterText: 'keyword filter',
		},
		selectLang: {
			switchLang: 'switch lang',
		},
	},
};
